import { useContext } from 'react';
import Sentinel from '@/common/Sentinel';
import { MAX_VEHICLES_TO_DISPLAY } from '~/constants/new-cars/constants';
import SectionName from '~/constants/new-cars/SectionName';
import ParentModelContext from '~/context/new-cars/ParentModelContext';
import useClosestVehicle from '~/hooks/new-cars/selectors/useClosestVehicle';
import useEffectiveModel from '~/hooks/new-cars/selectors/useEffectiveModel';
import useTotalMatchingVehicles from '~/hooks/new-cars/selectors/useTotalMatchingVehicles';
import useVehicleName from '~/hooks/new-cars/selectors/useVehicleName';
import { Subtitle, Title } from './ViewVehiclesModal.styles';

type OwnProps = {
  onIntersectionChange: (isIntersecting: boolean) => void;
};

export default function ContentHeader({ onIntersectionChange }: OwnProps) {
  const { activeSection } = useContext(ParentModelContext);
  const closestVehicle = useClosestVehicle();
  const totalMatchingVehicles = useTotalMatchingVehicles();
  const vehicleName = useVehicleName();
  const model = useEffectiveModel(true);

  return (
    <section
      className="flex flex-col gap-xl text-text-strong"
      data-testid="view-matches-modal-content-header"
    >
      <div>
        <Title>{vehicleName}</Title>
        <Sentinel onIntersectionChange={onIntersectionChange} />
      </div>

      {closestVehicle ? (
        <Subtitle>
          We have <span className="t-strong-md">a perfect match in stock</span>{' '}
          that includes all of your selections!
        </Subtitle>
      ) : totalMatchingVehicles <= MAX_VEHICLES_TO_DISPLAY ? (
        activeSection === SectionName.Options ? (
          <Subtitle>
            We found{' '}
            <span className="t-strong-md">
              {totalMatchingVehicles.toLocaleString()} {model} in stock
            </span>{' '}
            that include all of your selections – and more!
          </Subtitle>
        ) : (
          <Subtitle>
            We have{' '}
            <span className="t-strong-md">
              {totalMatchingVehicles.toLocaleString()} {model} in stock
            </span>{' '}
            to consider
          </Subtitle>
        )
      ) : (
        <Subtitle>
          We have over{' '}
          <span className="t-strong-md">
            {totalMatchingVehicles.toLocaleString()} {model}
          </span>{' '}
          in stock – here are {MAX_VEHICLES_TO_DISPLAY} to consider
        </Subtitle>
      )}
    </section>
  );
}
